import { generatePath } from 'react-router-dom'
import { ToastOptions } from 'react-toastify'
import { pluralize } from '@opallabs/lambda'
import { Link, Toast, ToastComponent } from '@opallabs/lapidary'
import { OpalRoutes } from '@opallabs/routing'
import { SelectionMeta, MomentData } from '../types'

export const addToPlanDefaultToastOptions: ToastOptions = {
  type: 'success',
  toastId: 'add-to-plan-toast',
  closeOnClick: true,
  autoClose: 5000,
}

const getMessageStart = (moments: MomentData[]) => {
  if (moments.length === 1) {
    return `The moment "${moments[0].title}" was`
  }

  return `${moments.length} moments were`
}

export const AddToPlanSuccessToast: ToastComponent<
  Omit<SelectionMeta, 'invalidMomentCount'> & { workspaceSlug: string }
> = ({ moments, plan, workspaceSlug, ...toastProps }) => {
  const planHref = plan.parentBlock?.parentPlan
    ? generatePath(OpalRoutes.Block, {
        workspaceSlug,
        planId: plan.parentBlock.parentPlan.id,
        blockId: plan.parentBlock.id,
        planViewMode: 'edit',
        blockViewMode: 'edit',
      }) + '#table'
    : generatePath(OpalRoutes.Plan, {
        workspaceSlug,
        planId: plan.id,
        planViewMode: 'edit',
      }) + '#table'

  return (
    <Toast
      {...toastProps}
      title={`${pluralize('Moment', moments.length)} added to plan`}
      message={
        <span>
          {`${getMessageStart(moments)} added to the plan `}
          <Link href={planHref} target="_top">
            {plan.title}
          </Link>
        </span>
      }
    />
  )
}
